module.exports = __webpack_public_path__ + "static/media/tz.9043b37f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tz.svg
// module id = 274
// module chunks = 0